import {
  ControlMessage,
  FullScreenMessage,
  InAppMessage,
  ModalMessage,
} from "@braze/web-sdk";

import { isNative } from "@origin-digital/platform-helpers";
import { EnvironmentNames } from "@origin-digital/platform-enums";

import {
  DASHBOARD_PATHNAME,
  MY_ACCOUNT_REWARDS_PATH,
  MY_ACCOUNT_ROUTE_PREFIX,
  MY_ACCOUNT_SURVEY_PATH,
  TASK_COMPLETION_SURVEY_ID,
} from "../utils/config";
import { LOG_TAG } from "../consts/consts";

export const LOG_MESSAGES = {
  SURVEY_APP_IGNORE: `${LOG_TAG} message received within survey app - ignoring`,
  PREVENT_WEB: `${LOG_TAG} prevent showing in-app message in web`,
  PREVENT_NATIVE: `${LOG_TAG} prevent showing in-app message in native`,
  CONTROL_GROUP: `${LOG_TAG} show in app message - control group`,
  ERROR: `${LOG_TAG} error processing in-app message`,
} as const;

// Type guards
export const hasButtons = (
  message: InAppMessage | ControlMessage
): message is ModalMessage | FullScreenMessage => {
  return (
    "buttons" in message &&
    Array.isArray(message.buttons) &&
    message.buttons.length > 0
  );
};

export const isInAppMessage = (
  message: InAppMessage | ControlMessage
): message is InAppMessage => {
  return !message.isControl;
};

// dont show instances
export const shouldHideInWeb = (extras?: InAppMessage["extras"]) =>
  !isNative() && extras?.showAppOnly === "true";

export const shouldHideInNative = (extras?: InAppMessage["extras"]) =>
  isNative() && extras?.showWebOnly === "true";

export const isSurveyPath = (path: string) =>
  path.startsWith(MY_ACCOUNT_SURVEY_PATH);

// show instances
export const isCompletionSurveyMessage = (
  path: string,
  environment: EnvironmentNames,
  extras?: InAppMessage["extras"]
) =>
  (path.startsWith(MY_ACCOUNT_ROUTE_PREFIX) || environment === "local") &&
  extras?.id === TASK_COMPLETION_SURVEY_ID;

export const isAllowedToShow = (path: string, environment: EnvironmentNames) =>
  path === DASHBOARD_PATHNAME ||
  path === MY_ACCOUNT_REWARDS_PATH ||
  environment === "local";
